import moment from 'moment';

import { Range } from '@dreryk/watermelon';

import { visitPaths } from '~libs.desktop.shared.paths';

import { DateFilter, DateFilterType } from './DateChipFilter.types';

export const DATE_RANGE_SEPARATOR = '\u002C' as const; // comma

export const isToday = (date: Date): boolean => {
   const today = new Date();
   return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
   );
};

const changeDay = (date: Date, offset: number): Date => {
   const newDate = new Date(date);
   newDate.setDate(date.getDate() + offset);
   return newDate;
};

export const getNextDay = (date: Date): Date => {
   return changeDay(date, 1);
};

export const getStartOfDay = (date: Date | string | number): Date => {
   const newDate = new Date(date);
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
   newDate.setHours(0, 0, 0, 0);
   return newDate;
};

export const getEndOfDay = (date: Date | string | number): Date => {
   const newDate = new Date(date);
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
   newDate.setHours(23, 59, 59);
   return newDate;
};

export const getToday = (): Date => {
   return new Date();
};

const DATE_RANGE_REGEXP = /\d{4}-\d{2}-\d{2}(?<OPTIONAL_END_DATE>,\d{4}-\d{2}-\d{2})?/u; // YYYY-MM-DD or YYYY-MM-DD,YYYY-MM-DD

export const mapDateFilterParamToDateFilter = (serializedDate: string | null): DateFilter | null => {
   if (!serializedDate?.length) {
      return null;
   }

   if (serializedDate === visitPaths.APPOINTMENTS_DATE_TODAY_SEARCH_PARAM_VALUE) {
      const today = getToday();

      return {
         type: DateFilterType.TODAY,
         range: Range.closed(getStartOfDay(today), getEndOfDay(today)),
      };
   }

   if (DATE_RANGE_REGEXP.test(serializedDate)) {
      const [startDate, endDate] = serializedDate.split(DATE_RANGE_SEPARATOR);
      const parsedStartDateInMs = Date.parse(startDate);
      if (isNaN(parsedStartDateInMs)) {
         return null;
      }

      const parsedStartDate = new Date(parsedStartDateInMs);

      if (endDate) {
         const parsedEndDateIsMs = Date.parse(endDate);
         if (isNaN(parsedStartDateInMs)) {
            return null;
         }

         const parsedEndDate = new Date(parsedEndDateIsMs);

         return {
            type: DateFilterType.RANGE,
            range: Range.closed(getStartOfDay(parsedStartDate), getEndOfDay(parsedEndDate)),
         };
      }

      return {
         type: DateFilterType.DAY,
         range: Range.closed(getStartOfDay(parsedStartDate), getEndOfDay(parsedStartDate)),
      };
   }

   return null;
};

export const formatDateToUrl = (date: Date): string => moment(date).format('YYYY-MM-DD');
